/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import useStyle from './checklistDisplay.module.scss';
import Clickable from '../../../components/clickable/Clickable';
import Collapsible from '../../../components/collapsible/Collapsible';

class InspectionChecklist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      useRemarks: {
        openRemarks: false,
        remarkVal: ''
      }
    };
    this.useTextSty = {
      margin: '12px',
      border: '1px solid #E6EAEE',
      borderRadius: '4px',
      width: '250px',
      maxHeight: 350,
      minHeight: 40,
      resize: 'block',
      height: 40,
      marginTop: '6px',
      paddingTop: '10px'
    };
  }

  handleActionRemarks = (newState) => {
    const { useRemarks } = this.state;
    this.setState({
      useRemarks: {
        ...useRemarks,
        ...newState
      }
    });
  };

  handleStatusFlag = (mainCheckId, subCheckId, isSuccess) => {
    let useStatus;
    const { answer } = this.props;

    if (typeof isSuccess === 'boolean' && !isSuccess) {
      if (answer?.[mainCheckId] && subCheckId in answer?.[mainCheckId]) {
        useStatus = answer?.[mainCheckId]?.[subCheckId]?.check_lilst_status
          ? useStyle.inactive
          : useStyle.active;
      } else {
        useStatus = useStyle.inactive;
      }
    } else if (isSuccess === 'N/A') {
      if (answer?.[mainCheckId] && subCheckId in answer?.[mainCheckId]) {
        if (answer?.[mainCheckId]?.[subCheckId]?.check_lilst_status !== 'N/A') {
          useStatus = useStyle?.inactive;
        } else if (answer?.[mainCheckId]?.[subCheckId]?.check_lilst_status === 'N/A') {
          useStatus = useStyle?.active;
        }
      }
    } else {
      useStatus = answer?.[mainCheckId]?.[subCheckId]?.check_lilst_status === true
        ? useStyle.active
        : useStyle.inactive;
    }
    return useStatus;
  };

  checkStatusDot = (mainCheckId, subCheckId) => {
    let useDot;
    const { answer } = this.props;

    if (answer?.[mainCheckId] && subCheckId in answer?.[mainCheckId]) {
      if (answer?.[mainCheckId]?.[subCheckId]?.check_lilst_status === true) {
        useDot = useStyle.success1;
      } else if (answer?.[mainCheckId]?.[subCheckId]?.check_lilst_status === false) {
        useDot = useStyle.failure1;
      } else if (answer?.[mainCheckId]?.[subCheckId]?.check_lilst_status === 'N/A') {
        useDot = useStyle.na1;
      } else {
        useDot = useStyle.untouched;
      }
    } else {
      useDot = useStyle.untouched;
    }
    return useDot;
  };

  handleRemarksPerChecklist = (checkListId, subChecklistId, value) => {
    const { fieldId, handleValueChange, answer } = this.props;
    let remarkStatus = answer?.[checkListId]?.[subChecklistId]?.check_lilst_status || false;
    handleValueChange(
      fieldId,
      checkListId,
      subChecklistId,
      remarkStatus,
      value
    );
  };

  render() {
    const { useRemarks } = this.state;
    const {
      handleValueChange,
      answer = false,
      displayChecklist,
      schema,
      version_settings,
      fieldId
    } = this.props;
    return (
      <div className={useStyle.fullWidth}>
        <div className={useStyle.itemWrapper}>
          {schema?.fields?.length > 0
            && schema.fields
              .filter(fieldtype => fieldtype.type === 'inspection')
              ?.map(eachCheck => (
                <React.Fragment key={eachCheck.id}>
                  <Collapsible
                    title={eachCheck?.title || 'New'}
                    styleClasses={`${useStyle.checkListHeading}`}
                    openOnMount
                    autoheight
                    offset={'1rem'}
                  >
                    {eachCheck?.checklist?.map(subCheck => (
                      <React.Fragment key={subCheck.key}>
                        <div
                          className={useStyle.checklist__item}
                          style={{ marginTop: '0.8rem' }}
                        >
                          <span className={useStyle.checklist__item__data}>
                            <span
                              className={`${useStyle.statusDot} ${
                                !answer
                                  ? useStyle.untouched
                                  : this.checkStatusDot(
                                      eachCheck?.id,
                                      subCheck.key
                                    )
                              }`}
                            />
                            {subCheck?.value}
                          </span>
                          <div className={useStyle.checkWrap}>
                            <div className={useStyle.standard}>
                              <div
                                className={`${useStyle.checklist__item__btnContainer} ${useStyle.checklist__item__data}`}
                              >
                                <Clickable
                                  className={`${
                                    useStyle.success
                                  } ${this.handleStatusFlag(
                                    eachCheck?.id,
                                    subCheck?.key,
                                    true
                                  )}`}
                                  onClick={() => {
                                    handleValueChange(
                                      fieldId,
                                      eachCheck.id,
                                      subCheck.key,
                                      true
                                    );
                                    this.handleActionRemarks({
                                      satisfiedRemark: true,
                                      sub_checkId: subCheck?.key,
                                      checkId: eachCheck?.id
                                    });
                                  }}
                                />
                                <Clickable
                                  className={`${
                                    useStyle.failure
                                  } ${this.handleStatusFlag(
                                    eachCheck?.id,
                                    subCheck?.key,
                                    false
                                  )}`}
                                  onClick={() => {
                                    handleValueChange(
                                      fieldId,
                                      eachCheck.id,
                                      subCheck.key,
                                      false
                                    );
                                    this.handleActionRemarks({
                                      satisfiedRemark: false,
                                      sub_checkId: subCheck?.key,
                                      checkId: eachCheck?.id
                                    });
                                  }}
                                />
                                {(version_settings?.na_option || subCheck?.settings?.enable_NA) && (
                                  <Clickable
                                    className={`${useStyle.na
                                      } ${this.handleStatusFlag(
                                        eachCheck?.id,
                                        subCheck?.key,
                                        'N/A'
                                      ) || useStyle.inactive}`}
                                    onClick={() => {
                                      handleValueChange(
                                        fieldId,
                                        eachCheck.id,
                                        subCheck.key,
                                        'N/A'
                                      );
                                      this.handleActionRemarks({
                                        satisfiedRemark: 'N/A',
                                        sub_checkId: subCheck?.key,
                                        checkId: eachCheck?.id
                                      });
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <textarea
                              rows="2"
                              defaultValue={useRemarks.remarkVal || ''}
                              value={
                                answer[eachCheck.id]?.[subCheck?.key]
                                  ?.checklist_remarks_list || ''
                              }
                              onChange={(e) => {
                                this.handleRemarksPerChecklist(
                                  eachCheck.id,
                                  subCheck?.key,
                                  e.target.value
                                );
                              }}
                              style={this.useTextSty}
                              className={useStyle.remarks}
                              name={'NewReamrks'}
                              disabled={
                                (!(useRemarks.checkId === eachCheck.id && useRemarks.sub_checkId === subCheck?.key)
                           && !answer[eachCheck.id]?.[subCheck?.key]) || displayChecklist
                              }
                              placeholder="Remarks"
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </Collapsible>
                </React.Fragment>
              ))}
        </div>
      </div>
    );
  }
}

export default InspectionChecklist;
